import Action from 'redux/helpers/createAction'
const name = 'keywordFinder'

export const getResults = Action(name + '/GET_RESULTS')

export const getKeywordFinderResults = Action(name + '/GET_KEYWORD_FINDER_RESULTS')

export const getKeywordFinderSuggestionsSuccess = Action(
  name + '/GET_KEYWORD_FINDER_SUGGESTIONS_SUCCESS',
  data => ({
    data
  })
)

export const getKeywordFinderSuggestionsFailure = Action(
  name + '/GET_KEYWORD_FINDER_SUGGESTIONS_FAILURE',
  error => ({
    error
  })
)

export const getKeywordFinderRelatedSuccess = Action(
  name + '/GET_KEYWORD_FINDER_RELATED_SUCCESS',
  data => ({
    data
  })
)

export const getKeywordFinderRelatedFailure = Action(
  name + '/GET_KEYWORD_FINDER_RELATED_FAILURE',
  error => ({
    error
  })
)

export const getKeywordFinderIdeasSuccess = Action(
  name + '/GET_KEYWORD_FINDER_IDEAS_SUCCESS',
  data => ({
    data
  })
)

export const getKeywordFinderIdeasFailure = Action(
  name + '/GET_KEYWORD_FINDER_IDEAS_FAILURE',
  error => ({
    error
  })
)

export const getKeywordFinderDomain = Action(name + '/GET_KEYWORD_FINDER_DOMAIN')

export const getKeywordFinderDomainSuccess = Action(
  name + '/GET_KEYWORD_FINDER_DOMAIN_SUCCESS',
  data => ({
    data
  })
)

export const getKeywordFinderDomainFailure = Action(
  name + '/GET_KEYWORD_FINDER_DOMAIN_FAILURE',
  error => ({
    error
  })
)

export const getKeywordFinderHistory = Action(name + '/GET_KEYWORD_FINDER_HISTORY')

export const getKeywordFinderHistorySuccess = Action(
  name + '/GET_KEYWORD_FINDER_HISTORY_SUCCESS',
  data => ({
    data
  })
)

export const getKeywordFinderHistoryFailure = Action(
  name + '/GET_KEYWORD_FINDER_HISTORY_FAILURE',
  error => ({
    error
  })
)

export const getKeywordSuggestionsByDomain = Action(
  name + '/GET_KEYWORD_SUGGESTIONS_BY_DOMAIN',
  domainData => ({
    domainData
  })
)

export const getKeywordSuggestionsByDomainSuccess = Action(
  name + '/GET_KEYWORD_SUGGESTIONS_BY_DOMAIN_SUCCESS',
  data => ({
    data
  })
)
export const resetKeywordSuggestionsByDomain = Action(name + '/RESET_KEYWORD_SUGGESTIONS_BY_DOMAIN')

export const getKeywordSuggestionsByDomainFailure = Action(
  name + '/GET_KEYWORD_SUGGESTIONS_BY_DOMAIN_FAILURE',
  error => ({
    error
  })
)

export const getKeywordFinderKD = Action(
  name + '/getKeywordFinderKD',
  (keywordId, keywordInfoId) => ({
    keywordId,
    keywordInfoId
  })
)

export const getKeywordFinderKDSuccess = Action(
  name + '/getKeywordFinderKDSuccess',
  (results, keywordId, inQueue, difficulty) => ({
    results,
    keywordId,
    inQueue,
    difficulty
  })
)

export const getKeywordFinderKDFailure = Action(
  name + '/getKeywordFinderKDFailure',
  (error, id, keywordId) => ({
    error,
    id,
    keywordId
  })
)
export const getKeywordFinderSERP = Action(
  name + '/getKeywordFinderSERP',
  (keywordId, keywordInfoId) => ({
    keywordId,
    keywordInfoId
  })
)

export const getKeywordFinderSERPSuccess = Action(
  name + '/getKeywordFinderSERPSuccess',
  (results, keywordId) => ({
    results,
    keywordId
  })
)

export const getKeywordFinderSERPFailure = Action(
  name + '/getKeywordFinderSERPFailure',
  (error, id, keywordId) => ({
    error,
    id,
    keywordId
  })
)

export const getLocales = Action(name + '/GET_LOCALES')

export const addKeywordsToList = Action(
  name + '/ADD_KEYWORD_FINDER_KEYWORDS_TO_LIST',
  selection => ({
    selection
  })
)

export const showResourcesError = Action(name + '/SHOW_RESOURCES_ERROR', showResourcesError => ({
  showResourcesError
}))

export const getLocalesSuccess = Action(name + '/GET_LOCALES_SUCCESS', data => ({
  data
}))

export const getLocalesFailure = Action(name + '/GET_LOCALES_FAILURE', error => ({
  error
}))

export const loadPrevious = Action(name + '/LOAD_PREVIOUS', historyId => ({
  historyId
}))

export const loadPreviousSuccess = Action(name + '/LOAD_PREVIOUS_SUCCESS', data => ({
  data
}))

export const loadPreviousFailure = Action(name + '/LOAD_PREVIOUS_FAILURE', error => ({
  error
}))

export const getKeywordFinderSuggestionsNotReady = Action(
  name + '/GET_KEYWORD_FINDER_SUGGESTIONS_NOT_READY'
)

export const getKeywordFinderRelatedNotReady = Action(
  name + '/GET_KEYWORD_FINDER_RELATED_NOT_READY'
)

export const getKeywordFinderIdeasNotReady = Action(name + '/GET_KEYWORD_FINDER_IDEAS_NOT_READY')

export const getKeywordFinderSuggestionsPartialSuccess = Action(
  name + '/GET_KEYWORD_FINDER_SUGGESTIONS_PARTIAL_SUCCESS',
  data => ({
    data
  })
)

export const getKeywordFinderRelatedPartialSuccess = Action(
  name + '/GET_KEYWORD_FINDER_RELATED_PARTIAL_SUCCESS',
  data => ({
    data
  })
)

export const getKeywordFinderIdeasPartialSuccess = Action(
  name + '/GET_KEYWORD_FINDER_IDEAS_PARTIAL_SUCCESS',
  data => ({
    data
  })
)

export const deleteKeywords = Action(
  name + '/DELETE_KEYWORD_FINDER_RESULTS_KEYWORDS',
  historyId => ({
    historyId
  })
)

export const deleteKeywordsSuccess = Action(
  name + '/DELETE_KEYWORD_FINDER_RESULTS_KEYWORDS_SUCCESS',
  data => ({
    data
  })
)

export const deleteKeywordsFailure = Action(
  name + '/DELETE_KEYWORD_FINDER_RESULTS_KEYWORDS_FAILURE',
  error => ({
    error
  })
)
